import { useState } from 'react';
import DashboardEmbed from '@/components/DashboardEmbed';

const DASHBOARD_ID = 'dbe35905-fe7a-4971-a502-0e0e5fbe7a3d';

const CURRENT_YEAR = new Date().getFullYear();
const YEARS = [CURRENT_YEAR, CURRENT_YEAR - 1];

function buildEmbedConfig(username: string, year: number) {
  return {
    dashboard_id: DASHBOARD_ID,
    filters: {
      username_year: `${username}_${year}`,
    },
  };
}

export default function DashboardPage() {
  const [username, setUsername] = useState('');
  const [year, setYear]         = useState(CURRENT_YEAR);
  const [submitted, setSubmitted] = useState<{ username: string; year: number } | null>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const clean = username.trim();
    if (!clean) return;
    setSubmitted({ username: clean, year });
  };

  const embedConfig = submitted ? buildEmbedConfig(submitted.username, submitted.year) : null;

  return (
    <div className="dash-page">
      <header className="dash-header">
        <span className="pulse-eyebrow">Looker Studio</span>
        <h1 className="dash-title">Dashboard</h1>
        <p className="dash-sub">
          Full interactive breakdown of any tracked player's games, powered by BigQuery and dbt.
          Enter a Chess.com username to load their personalized report.
        </p>
      </header>

      <form className="dash-form" onSubmit={handleSubmit} aria-label="Load dashboard">
        <div className="dash-form-row">
          <div className="dash-field">
            <label htmlFor="dash-username" className="dash-label">Chess.com username</label>
            <input
              id="dash-username"
              type="text"
              className="dash-input"
              placeholder="e.g. EdwardL903"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="off"
              spellCheck={false}
            />
          </div>

          <div className="dash-field dash-field--year">
            <label htmlFor="dash-year" className="dash-label">Year</label>
            <select
              id="dash-year"
              className="dash-input dash-select"
              value={year}
              onChange={(e) => setYear(Number(e.target.value))}
            >
              {YEARS.map((y) => (
                <option key={y} value={y}>{y}</option>
              ))}
            </select>
          </div>

          <button type="submit" className="dash-btn">
            Load Dashboard
          </button>
        </div>
      </form>

      {submitted ? (
        <DashboardEmbed
          dashboardUrl={null}
          embedConfig={embedConfig}
        />
      ) : (
        <div className="dash-placeholder">
          <span className="dash-placeholder-piece" aria-hidden>♜</span>
          <p className="dash-placeholder-text">Enter a username above to load the interactive report.</p>
          <p className="dash-placeholder-note">
            Only players in the ChessLytics dataset will have data available.
          </p>
        </div>
      )}
    </div>
  );
}
